/*
 * @Author: brucexlliu
 * @Date: 2022-05-30 14:42:47
 * @LastEditors: brucexlliu
 * @LastEditTime: 2022-05-30 14:47:14
 * @Description:
 * @FilePath: \wemeet-web-activity\src\components\DateTimePicker\util.js
 */
export const setPosition = (element, posStart, posEnd = -1) => {
  if (element.setSelectionRange) {
    // IE9 Support and so on
    element.focus();
    element.setSelectionRange(posStart, posEnd);
  } else if (element.createTextRange) {
    // Firefox support
    const range = element.createTextRange();
    range.collapse(true);
    range.moveStart('character', posStart);
    range.moveEnd('character', posEnd);
    range.select();
  }
};

export function noLessThan(firTime = '', secTime = '') {
  const fir = firTime.split(':');
  const sec = secTime.split(':');
  if (fir[0] !== sec[0]) {
    return fir[0] > sec[0];
  }
  return fir[1] >= sec[1];
}

export function getTimeOfNearHalfHour(nextHalfHourDate) {
  const hour = nextHalfHourDate?.hours();
  const hours = hour > 9 ? `${hour}` : `0${hour}`;
  let minutes = '00';
  if (nextHalfHourDate.minutes() > 29) {
    minutes = '30';
  }
  return `${hours}:${minutes}`;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const timeSelectOptions = Array.from({ length: 48 })
  .map((_, index) => {
    const hours = Math.floor(index / 2) > 9
      ? `${Math.floor(index / 2)}`
      : `0${Math.floor(index / 2)}`;
    const minutes = index % 2 ? '30' : '00';
    return `${hours}:${minutes}`;
  });

export function addNumberPerfix(v = 0) {
  return v < 10 ? `0${v}` : `${v}`;
}
